import { useState, useEffect } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { useAuth } from '../../../Providers/AuthProvider';
import { useConfig } from '../../../Providers/ConfigProvider';
import { checkIfPasswordMeetsConditions, passwordConditionText } from '../../../Helpers/CheckPassword';
import { ChangePassword } from '../../../Services/UserService';

const ChangePasswordPanel = ({ user, isChangePasswordVisible, setIsChangePasswordVisible }) => {
    const [passwords, setPasswords] = useState({ current_password: '', new_password: '', repeated_new_password: '' })
    const { logout, handleGetUserPassword } = useAuth()
    const { api } = useConfig()
    const [error, setError] = useState('');
    const validationResults = checkIfPasswordMeetsConditions(passwords.new_password);
    const [isPasswordMeetsConditions, setIsPasswordMeetsConditions] = useState(true)
    const [currentPassword, setCurrentPassword] = useState('')
    const missingRequirements = Object.values(validationResults)
        .filter((data) => data && !data.valid)
        .map((data) => data.description)
        .join(", ");

    useEffect(() => {
        const getUserPassword = async () => {
            let password = await handleGetUserPassword()
            setCurrentPassword(password)
        }
        getUserPassword()
    }, [])

    const handleEditPasswords = (e) => {
        const { name, value } = e.target;
        setError('')
        setPasswords({
            ...passwords,
            [name]: value
        })
    }

    const handleCancelButtonClick = () => {
        setPasswords({ current_password: '', new_password: '', repeated_new_password: '' })
        setError('')
        setIsChangePasswordVisible(false);
    }

    const handleChangePassword = () => {
        if (passwords.current_password === '' || passwords.new_password === '' || passwords.repeated_new_password === '') {
            setError('Wszystkie pola muszą być wypełnione!')
        } else if (passwords.current_password !== currentPassword) {
            setError('Wpisane hasło niezgodne z aktualnym hasłem!')
        } else if (passwords.current_password === passwords.new_password) {
            setError('Nowe hasło musi różnić się od aktualnego!')
        } else if (passwords.new_password != passwords.repeated_new_password) {
            setError('Powtórzone hasło musi być zgodne z nowym hasłem!')
        } else if (missingRequirements.length > 0) {
            setIsPasswordMeetsConditions(false)
            return;
        } else {
            ChangePassword(api, user.userId, { currentPassword: passwords.current_password, newPassword: passwords.new_password })
                .then(() => {
                    setPasswords({ current_password: '', new_password: '', repeated_new_password: '' })
                    setIsChangePasswordVisible(false);
                    setError('')
                    logout(true)
                })
                .catch(e => {
                    console.log(e)
                    setError(e.response.data)
                })
        }
    }

    return <>
        <Modal size='lg' show={isChangePasswordVisible} onHide={handleCancelButtonClick} centered>
            <Modal.Header closeButton>
                <Modal.Title>Zmień hasło</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <GivePasswordData
                    handleEditPasswords={handleEditPasswords}
                    handleChangePassword={handleChangePassword}
                    isPasswordMeetsConditions={isPasswordMeetsConditions}
                    error={error}
                />
            </Modal.Body>
        </Modal>
    </>
}

const GivePasswordData = ({ handleEditPasswords, handleChangePassword, isPasswordMeetsConditions, error }) => {
    let passwordConditionsTextStyle = isPasswordMeetsConditions ? '' : 'error-text-color'
    return <>
        <div className="cont profile-details-info">
            <div className="row data-container mt-2">
                <div className="col-12 col-md">
                    <div className="row d-flex">
                        <div className="col d-flex">
                            <Form.Label>Aktualne hasło</Form.Label>
                            <span className='error-text-color'>&nbsp;*</span>
                        </div>
                    </div>
                    <Form.Control type='password' name='current_password' placeholder='Aktualne hasło' readOnly={false} onChange={handleEditPasswords} autoComplete='old-password' autoFocus required />
                </div>
                <div className='col'>

                </div>
            </div>
            <div className="row data-container mt-4">
                <div className="col-12 col-md">
                    <div className="row">
                        <div className="col d-flex">
                            <Form.Label>Nowe hasło</Form.Label>
                            <span className='error-text-color'>&nbsp;*</span>
                        </div>
                    </div>
                    <Form.Control type='password' name='new_password' placeholder='Nowe hasło' readOnly={false} onChange={handleEditPasswords} autoComplete='new-password' required />
                </div>
                <div className="col-12 col-md mt-4 mt-md">
                    <div className="row">
                        <div className="col">
                            <Form.Label>Powtórz hasło</Form.Label>
                            <span className='error-text-color'>&nbsp;*</span>
                        </div>
                    </div>

                    <Form.Control type='password' name='repeated_new_password' placeholder='Powtórz hasło' readOnly={false} onChange={handleEditPasswords} autoComplete='new-repeated-password' required />
                </div>
            </div>
            <div className="row data-container mt-4">
                <span className={passwordConditionsTextStyle}>{passwordConditionText}</span>
            </div>
            <div className="row data-container">
                <span>
                    <span className='error-text-color'>*</span> Pole wymagane
                </span>
            </div>
            {error.length > 0 ? (<div className="row error-text-color justify-content-center mb-4">{error}</div>) : (<></>)}
            <div className="row data-container mt-4">
                <div className="col-12 col-md d-grid">
                    <button className='btn-app-primary' onClick={handleChangePassword}>
                        Zmień hasło
                    </button>
                </div>
                <div className='col'>

                </div>
            </div>
        </div>
    </>
}

export default ChangePasswordPanel; 